module.exports = __webpack_public_path__ + "img/画板4@2x.fa99b17e.png";